import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Loader from 'Molecules/Loader/Loader';

import useAuthentication from 'Hooks/useAuthentication';
import useUserpilot from './useUserpilot';
import useIntercom from './useIntercom';
import useLaunchDarkly from './useLaunchDarkly';

import { selectOrganizationId } from 'state/User/userSlice';
import { getOrganization } from 'state/Organization/organizationSlice';

const AuthenticatedPage = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAuthentication();
  const isIntercomInitialized = useIntercom();
  const isUserpilotInitialized = useUserpilot();
  const isLaunchDarklyInitialized = useLaunchDarkly();
  const areServicesInitialized = useMemo<boolean>(
    () =>
      isIntercomInitialized &&
      isUserpilotInitialized &&
      isLaunchDarklyInitialized,
    [isIntercomInitialized, isUserpilotInitialized, isLaunchDarklyInitialized]
  );

  const dispatch = useDispatch();
  const organizationId = useSelector(selectOrganizationId);

  useEffect(() => {
    if (organizationId) {
      dispatch(getOrganization(organizationId));
    }
  }, [organizationId, dispatch]);

  if (!areServicesInitialized || !isAuthenticated) {
    return (
      <div className='flex h-screen px-16'>
        <Loader />
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthenticatedPage;
